
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { FamilyProfileForm } from "./FamilyProfileForm";
import { useState } from "react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface FamilyProfileDialogProps {
  onComplete?: () => void;
}

export function FamilyProfileDialog({ onComplete }: FamilyProfileDialogProps) {
  const [open, setOpen] = useState(false);
  const { language } = useLanguage();

  const handleComplete = () => {
    setOpen(false);
    if (onComplete) {
      onComplete();
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">{t('statistics.editFamilyProfile', language)}</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>{t('family.information', language)}</DialogTitle>
          <DialogDescription>
            {t('family.information', language)}
          </DialogDescription>
        </DialogHeader>
        <FamilyProfileForm onComplete={handleComplete} />
      </DialogContent>
    </Dialog>
  );
}
